import type { IOverleveringChecklistRow } from "@mcapps/shared/startupChecklists/templates/901-overlevering/901Schema";
import { Progress901 } from "./templates/901-overlevering/901Progress";
import type { IForenkletStyringNivaa1Report } from "@mcapps/shared/startupChecklists/templates/902-forenklet-styring/902InitialData";
import { Progress902 } from "./templates/902-forenklet-styring/902Progress";
import { Group, Paper, Stack, Text, Title } from "@mantine/core";

type Props = {
  templateId: number;
  reportName: string;
  reportData?: object | null;
  createdAt?: string | Date | null;
  updatedAt?: string | Date | null;
  createdByName?: string | null;
  assignmentName?: string | null;
  mainAssignmentNumber?: string | number | null;
  subAssignmentNumber?: string | null;
};

export const StartupChecklistHeader = ({
  templateId,
  reportName,
  reportData,
  createdAt,
  updatedAt,
  createdByName,
  assignmentName,
  mainAssignmentNumber,
  subAssignmentNumber,
}: Props) => {
  const heading =
    templateId === 901
      ? { title: "Overlevering av oppdrag", subtitle: "Fra TA og TL til OA og OL" }
      : { title: reportName, subtitle: null };
  const date = createdAt ? new Date(createdAt) : null;
  const createdDate =
    date && !Number.isNaN(date.getTime())
      ? date.toLocaleDateString("nb-NO", { day: "numeric", month: "long", year: "numeric" })
      : null;
  const updatedDate = updatedAt ? new Date(updatedAt) : null;
  const updatedDateTime =
    updatedDate && !Number.isNaN(updatedDate.getTime())
      ? updatedDate.toLocaleString("nb-NO", {
          day: "numeric",
          month: "long",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : null;
  return (
    <Paper withBorder radius="sm" mx="md" mt="xs" px="md" py="xs" style={{ flexShrink: 0 }}>
      <Group align="center" justify="space-between" gap="xl" wrap="wrap">
        <Stack gap="xs">
          <Stack gap={2}>
            <Title order={2} size="h3">
              {heading.title}
            </Title>
            {heading.subtitle && (
              <Text size="sm" c="dimmed">
                {heading.subtitle}
              </Text>
            )}
          </Stack>
          <Group component="dl" gap="lg" align="flex-start" wrap="wrap" m={0}>
            <Stack gap={2} style={{ minWidth: 0, maxWidth: 360 }}>
              <Text component="dt" size="xs" c="dimmed">
                Oppdragsnavn
              </Text>
              <Text component="dd" size="sm" fw={500} m={0}>
                {assignmentName || "—"}
              </Text>
            </Stack>
            <Stack gap={2}>
              <Text component="dt" size="xs" c="dimmed">
                Hovedoppdragsnummer
              </Text>
              <Text component="dd" size="sm" fw={500} m={0}>
                {mainAssignmentNumber ?? "—"}
              </Text>
            </Stack>
            <Stack gap={2}>
              <Text component="dt" size="xs" c="dimmed">
                Underoppdragsnummer
              </Text>
              <Text component="dd" size="sm" fw={500} m={0}>
                {subAssignmentNumber || "—"}
              </Text>
            </Stack>
          </Group>
          <Text size="xs" c="dimmed">
            Opprettet {createdDate ?? "– dato ikke registrert"} av {createdByName || "ukjent bruker"}
          </Text>
          {updatedDateTime && (
            <Text size="xs" c="dimmed">
              Sist oppdatert {updatedDateTime}
            </Text>
          )}
        </Stack>
        {templateId === 901 && reportData && (
          <Progress901 report={reportData as { rows: IOverleveringChecklistRow[] }} />
        )}
        {templateId === 902 && reportData && <Progress902 report={reportData as IForenkletStyringNivaa1Report} />}
      </Group>
    </Paper>
  );
};
